//Se manejan dos vistas en este archivo jsx tanto en la ficha de empleado(evaluaciones) como en el monitor (evaluacion del desempeño)
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";

import SidebarDashboard from "../../components/SidebarDashboard";
import ToggleableLink from "../../components/evaluacion_desempenio/ToggleableLink";
import {
  deleteEvaluationMonitor,
  editEvaluationMonitor,
  editEvaluationMonitorGD,
  getEvaluationMonitor,
  getQuestionFactor,
  getQuestionCompetency,
  getMetricaCompetencia,
  getMetricByFactor,
  editEvaluationMonitorNotAccept,
} from "../../redux/evaluacion_desempenio/EvaluationMonitor/actions";
import { getPlanAcciones } from "../../redux/evaluacion_desempenio/plan_accion/actions";
import config from "../../config";
import { getAreas, getCarpetas } from "../../redux/gestorDocumental/actions";
import { getBase64 } from "../../components/gestorDocumental/GestorDocumental";
import LinkDescargaListGD from "../../components/gestorDocumental/LinkDescargaListGD";
import LinkDescargaGD from "../../components/gestorDocumental/LinkDescargaGD";
import UserHeadDetail from "../../components/UserHeadDetail";
import { getFuncFichaEmpleado } from "../../redux/func_ficha_empleados/actions";
import UserHeadDetailMenu from "../../components/UserHeadDetailMenu";
import { getPeriodicityByOrg } from "../../redux/evaluacion_desempenio/Periodicity/actions";
import messages from "../../redux/messages";
import UpdateBoss from "../../components/evaluacion_desempenio/UpdateBoss";
import ExcelFile from "../../components/evaluacion_desempenio/ExcelFile";
import ExcelDownload from "../../components/evaluacion_desempenio/ExcelDownload";

const EvaluationMonitor = (props) => {
  const filters = [
    { id: "tipo_evaluacion_nombre", desc: "Tipo de evaluación" },
    { id: "evaluador_nombre", desc: "Evaluador" },
    { id: "periodo", desc: "Periodo de evaluación" },
  ];

  const fechaActual = new Date();

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [item, setItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalAcceptEvaluation, setShowModalAcceptEvaluation] =
    useState(false);
  const [showModalExcel, setShowModalExcel] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [tipoBusc, setTipoBusc] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);
  const [asignadas, setAsignadas] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  const userRoles = useSelector((store) => store.auth.userRoles);

  const fecha = new Date();
  var n = fecha.getFullYear();

  const schema = Yup.object().shape({
    tipo_plan_accion: Yup.string().required("**Campo requerido"),
    fecha_inicio: Yup.string().required("**Campo requerido"),
    fecha_fin: Yup.string().required("**Campo requerido"),
    evaluacion_archivo_plan_accion_gestor: Yup.string().when("edit", {
      is: () => edit === true && editItem.plan_induccion === null,
      then: Yup.string().required("**Campo requerido"),
    }),
  });

  const schemaAcceptEvaluation = Yup.object().shape({
    comentario: Yup.string().required("**Campo requerido"),
  });

  const { userType, id } = useSelector((store) => store.auth);

  const { ficha_empleado, loadingFicha_Empleado } = useSelector(
    (store) => store.funcTabEmployeed
  );

  const {
    loading,
    saveLoading,
    evaluationMonitorsLength,
    evaluationMonitors,
    evaluationMonitorError,
    formError,
    loadingQuestionFactor,
    loadingQuestionCompentey,
    questionFactor,
    questionCompetency,
    questionFactorError,
    questionCompetencyError,
  } = useSelector((store) => store.evaluationMonitor);
  const pages = Math.ceil(evaluationMonitorsLength / limit);

  const { loaderPlanAccion, planAccion, planAccionFalla } = useSelector(
    (store) => store.planAccion
  );

  const { areas, carpetas } = useSelector((store) => store.gestorDocumental);

  const { carpeta, tipoDocumentoGD } = config.gestorDocumental.evaluacion;
  const { area, email } = config.gestorDocumental;

  const { loading: loadingPeriodicity, periodicity } = useSelector(
    (store) => store.periodicity
  );

  const columns = [
    {
      Header: "Fecha de inicio periodo:",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "170px" }}>
          {value.row.original.list_evaluacion_configuracion_periodo &&
          value.row.original.list_evaluacion_configuracion_periodo[0]
            ? moment(
                value.row.original.list_evaluacion_configuracion_periodo[0]
                  .fecha_inicio
              ).format("DD/MM/YYYY")
            : ""}
        </div>
      ),
    },
    {
      Header: "Fecha de evaluación:",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "150px" }}>
          {value.row.original.fecha_evaluacion
            ? moment(value.row.original.fecha_evaluacion).format("DD/MM/YYYY")
            : null}
        </div>
      ),
    },
    {
      Header: "Periodo:",
      Filter: "",
      Cell: (value) => (
        <div
          className="d-flex justify-content-between"
          style={{
            minWidth: "130px",
          }}
        >
          {renderSwitch(value.row.original.periodo)} Periodo
        </div>
      ),
    },
    {
      Header: "Periodicidad:",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.periodicidad &&
          value.row.original.list_periodicidad[0].frecuencia
            ? value.row.original.list_periodicidad[0].list_frecuencia[0].nombre
            : ""}
        </div>
      ),
    },
    {
      Header: "Puntuación:",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_nota_total
            ? value.row.original.list_nota_total
            : "-"}
        </div>
      ),
    },
    {
      Header: "Desempeño:",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(
            value.row.original.list_evaluacion_configuracion_periodo[0]
              .fecha_fin
          ).format("DD/MM/YYYY") > moment().format("DD/MM/YYYY") &&
          value.row.original.list_nota_total
            ? value.row.original.list_nota_total_desempenio
            : "Evaluación Pendiente"}
        </div>
      ),
    },
    {
      Header: "Tipo de evaluación:",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "150px" }}>
          {value.row.original.tipo_evaluacion
            ? value.row.original.list_tipo_evaluacion[0].descripcion
            : ""}
        </div>
      ),
    },
    {
      Header: "Evaluador:",
      Filter: "",
      Cell: (value) => (
        <div
          className="d-flex justify-content-between"
          style={{
            minWidth: "110px",
          }}
        >
          <p>
            {value.row.original.evaluador
              ? value.row.original.list_evaluador[0].nombre
              : ""}
          </p>
        </div>
      ),
    },
    {
      Header: "Estado:",
      Filter: "",
      Cell: (value) => (
        <div
          className={`${
            value.row.original.estado
              ? "bg-success text-light"
              : // : "bg-danger text-light"
              value.row.original.estado === false
              ? "bg-primary text-light"
              : "bg-warning text-light"
          } p-2 rounded-pill text-center`}
          style={{
            minWidth: "90px",
          }}
        >
          {/* {value.row.original.estado ? "Abierto" : "Cerrado"} */}
          {value.row.original.estado
            ? "Abierto"
            : value.row.original.estado === false
            ? "Aceptó"
            : "No aceptó"}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="d-flex btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={
              <Tooltip {...props}>
                {props.match.params.type
                  ? value.row.original.evaluado ===
                      value.row.original.evaluador && value.row.original.estado
                    ? "Realizar"
                    : "Ver"
                  : value.row.original.estado
                  ? "Realizar"
                  : "Ver"}{" "}
                evaluación
              </Tooltip>
            }
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() =>
                history.push(
                  props.match.params.type
                    ? value.row.original.evaluado ===
                        value.row.original.evaluador ||
                      value.row.original.list_tipo_evaluacion[0].nombre ===
                        "180°" ||
                      value.row.original.list_tipo_evaluacion[0].nombre ===
                        "270°" ||
                      value.row.original.list_tipo_evaluacion[0].nombre ===
                        "360°"
                      ? `/evaluacion-del-desempenio/${props.match.params.id}/${props.match.params.type}/1/${value.row.original.listado_evaluaciones.evaluaciones_factor[0][0]}/${value.row.original.listado_evaluaciones.evaluaciones_competencia[0][0]}`
                      : `/evaluacion-del-desempenio/${props.match.params.id}/${props.match.params.type}/2/${value.row.original.listado_evaluaciones.evaluaciones_factor[0][0]}/${value.row.original.listado_evaluaciones.evaluaciones_competencia[0][0]}`
                    : (value.row.original.evaluado !== id &&
                        value.row.original.list_tipo_evaluacion[0].nombre ===
                          "0°") ||
                      value.row.original.list_tipo_evaluacion[0].nombre ===
                        "180°" ||
                      value.row.original.list_tipo_evaluacion[0].nombre ===
                        "270°" ||
                      value.row.original.list_tipo_evaluacion[0].nombre ===
                        "360°"
                    ? `/evaluacion-del-desempenio/autoevaluacion/${userType}/${id}/${userType}/2/${value.row.original.listado_evaluaciones.evaluaciones_factor[0][0]}/${value.row.original.listado_evaluaciones.evaluaciones_competencia[0][0]}`
                    : value.row.original.list_tipo_evaluacion[0].nombre ===
                      "90°"
                    ? `/evaluacion-desempenio/formulario-evaluacion-competencia/${value.row.original.listado_evaluaciones.evaluaciones_factor[0][0]}/${value.row.original.listado_evaluaciones.evaluaciones_competencia[0][0]}/${props.match.params.idEmpresa}`
                    : `/evaluacion-desempenio/formulario-autoevaluacion/${value.row.original.listado_evaluaciones.evaluaciones_factor[0][0]}/${value.row.original.listado_evaluaciones.evaluaciones_competencia[0][0]}/${props.match.params.idEmpresa}/0`
                )
              }
            >
              <i className="material-icons">dashboard</i>
            </Button>
          </OverlayTrigger>
          {/* {props.match.params.type ? null : (
            <> */}
          <ToggleableLink
            idColab={props.match.params.idColab}
            nombreColab={props.match.params.nombreColab}
            idFuncion={props.match.params.idFuncion}
            nombreFuncion={props.match.params.nombreFuncion}
            idDep={props.match.params.idDep}
            nombreDep={props.match.params.nombreDep}
            evaluation={value.row.original}
            idEmpresa={props.match.params.idEmpresa}
          >
            <i className="material-icons">donut_small</i>
          </ToggleableLink>
          {/* </>
          )} */}
          {props.match.params.type ||
          value.row.original.evaluado ===
            value.row.original.evaluador ? null : (
            <>
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Plan de acción</Tooltip>}
              >
                <Button
                  size="sm"
                  variant="link"
                  className="text-secondary"
                  type="button"
                  onClick={() =>
                    onAddActionPlan(value.row.original, value.row.index)
                  }
                >
                  <i className="material-icons">description</i>
                </Button>
              </OverlayTrigger>
            </>
          )}
          {value.row.original.evaluacion_archivo_plan_accion_gestor && (
            <OverlayTrigger
              placement="auto"
              overlay={<Tooltip {...props}>Ver documento subido</Tooltip>}
            >
              <LinkDescargaListGD
                id={value.row.original.id}
                filters={{
                  email: email,
                  id: value.row.original
                    .list_evaluacion_archivo_plan_accion_gestor[0].id_documento,
                  llave:
                    value.row.original
                      .list_evaluacion_archivo_plan_accion_gestor[0].llave,
                }}
                origen={
                  value.row.original
                    .list_evaluacion_archivo_plan_accion_gestor[0].origen
                }
                icono={<i className="material-icons">file</i>}
                cType={
                  value.row.original
                    .list_evaluacion_archivo_plan_accion_gestor[0].contentTypeGD
                }
              />
            </OverlayTrigger>
          )}
          {((props.match.params.type &&
            value.row.original.list_tipo_evaluacion[0].nombre !== "0°") ||
            (!props.match.params.type &&
              value.row.original.list_tipo_evaluacion[0].nombre === "0°")) &&
          !(
            value.row.original.list_tipo_evaluacion[0].nombre === "180°" ||
            value.row.original.list_tipo_evaluacion[0].nombre === "270°" ||
            value.row.original.list_tipo_evaluacion[0].nombre === "360°"
          ) ? (
            <>
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Aceptar evaluación</Tooltip>}
              >
                <Button
                  size="sm"
                  variant="link"
                  type="button"
                  onClick={() => onEdit(value.row.original, value.row.index)}
                >
                  <i className="material-icons">square</i>
                </Button>
              </OverlayTrigger>
            </>
          ) : null}
          {((props.match.params.type &&
            value.row.original.list_tipo_evaluacion[0].nombre !== "0°") ||
            (!props.match.params.type &&
              value.row.original.list_tipo_evaluacion[0].nombre === "0°")) &&
          !(
            value.row.original.list_tipo_evaluacion[0].nombre === "180°" ||
            value.row.original.list_tipo_evaluacion[0].nombre === "270°" ||
            value.row.original.list_tipo_evaluacion[0].nombre === "360°"
          ) ? (
            <>
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>No aceptar evaluación</Tooltip>}
              >
                <Button
                  size="sm"
                  variant="link"
                  type="button"
                  className="text-danger"
                  onClick={() =>
                    onNotAccept(value.row.original, value.row.index)
                  }
                  disabled={!value.row.original.estado}
                >
                  <i className="material-icons">square</i>
                </Button>
              </OverlayTrigger>
            </>
          ) : null}

          {props.match.params.type &&
          value.row.original.list_tipo_evaluacion[0].nombre === "360°" ? (
            <>
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Subir archivo</Tooltip>}
              >
                <Button
                  size="sm"
                  variant="link"
                  type="button"
                  onClick={() =>
                    onShowModalExcel(value.row.original, value.row.index)
                  }
                >
                  <i className="material-icons">upload_file</i>
                </Button>
              </OverlayTrigger>
            </>
          ) : null}

          {props.match.params.type &&
          value.row.original.list_tipo_evaluacion[0].nombre === "360°" ? (
            <>
              <ExcelDownload
                idFactor={
                  value.row.original.listado_evaluaciones
                    .evaluaciones_factor[0][0]
                }
                idCompetencia={
                  value.row.original.listado_evaluaciones
                    .evaluaciones_competencia[0][0]
                }
                idPeriodicidad={value.row.original.periodicidad}
              />
            </>
          ) : null}

          {userRoles.length > 0 &&
            (userRoles.includes("administrador") ||
              userRoles.includes("Responsable_Evaluacion")) &&
            value.row.original.list_tipo_evaluacion[0].nombre === "90°" && (
              <>
                {value.row.original.permiso_para_eliminar_actualizar
                  .actualizacion_jefe && (
                  <UpdateBoss
                    item={value.row.original}
                    index={value.row.index}
                    _getEvaluationMonitor={_getEvaluationMonitor}
                  />
                )}
                {value.row.original.permiso_para_eliminar_actualizar
                  .eliminacion && (
                  <OverlayTrigger
                    placement="auto"
                    overlay={<Tooltip {...props}>Eliminar evaluación</Tooltip>}
                  >
                    <Button
                      size="sm"
                      className="text-danger"
                      variant="link"
                      type="button"
                      disabled={
                        !value.row.original.permiso_para_eliminar_actualizar
                          .eliminacion
                      }
                      onClick={() => {
                        if (
                          value.row.original.permiso_para_eliminar_actualizar
                            .eliminacion
                        ) {
                          onDelete(value.row.original, value.row.index);
                        }
                      }}
                    >
                      <i className="material-icons">close</i>
                    </Button>
                  </OverlayTrigger>
                )}
              </>
            )}
        </div>
      ),
    },
  ];

  // Métodos
  const _getEvaluationMonitor = (
    offs = offset,
    lim = limit,
    filt = filter,
    _tipoBusc = tipoBusc,
    _asignadas = asignadas
  ) =>
    dispatch(
      getEvaluationMonitor({
        offset: offs,
        limit: lim,
        tipo_busqueda: _asignadas ? "evaluador_id" : "evaluado_id",
        filter: props.match.params.type
          ? parseInt(props.match.params.id)
          : parseInt(props.match.params.idColab),
        tipo_busqueda_2: tipoBusqueda.id,
        filter_2:
          tipoBusqueda.id === "periodo" && filt !== "" ? renderIf(filt) : filt,
        evaluaciones_actuales: !_asignadas ? _tipoBusc : "",
        enviada: props.match.params.type ? "True" : null,
      })
    );

  useEffect(() => {
    // _getEvaluationMonitor();
    dispatch(getPlanAcciones({}));
    dispatch(getAreas());
    dispatch(getCarpetas());
    if (
      props.match.params.idEmpresa &&
      !isNaN(props.match.params.idEmpresa) &&
      !props.match.params.type
    ) {
      dispatch(
        getPeriodicityByOrg({
          tipo_busqueda: "empresa__id",
          filter: parseInt(props.match.params.idEmpresa),
          tipo_busqueda_2: "clasificacion_id",
          filter_2: parseInt(props.match.params.idClasifi),
          tipo_busqueda_3: "anio",
          filter_3: parseInt(n),
        })
      );
    } else {
      _getEvaluationMonitor(offset, limit, filter, null);
    }
  }, [props.match.params.idEmpresa]);
  //validacion de mensaje
  useEffect(() => {
    if (
      ficha_empleado &&
      ficha_empleado.empresa_id &&
      props.match.params.type
    ) {
      dispatch(
        getPeriodicityByOrg({
          tipo_busqueda: "empresa__id",
          filter: parseInt(ficha_empleado.empresa_id[0]),
          tipo_busqueda_2: "clasificacion_id",
          filter_2: parseInt(ficha_empleado.clasificacion_empleado_id),
          tipo_busqueda_3: "anio",
          filter_3: parseInt(n),
        })
      );
    } else {
      _getEvaluationMonitor(offset, limit, filter, null);
    }
  }, [ficha_empleado]);

  useEffect(() => {
    if (periodicity.id) {
      setTipoBusc(periodicity.id);
      _getEvaluationMonitor(offset, limit, filter, periodicity.id);
    } else {
      setTipoBusc("");
      _getEvaluationMonitor(offset, limit, filter, null);
    }
  }, [periodicity]);

  useEffect(() => {
    if (props.match.params.type) {
      dispatch(
        getFuncFichaEmpleado(
          props.match.params.id,
          parseInt(props.match.params.type)
        )
      );
    }
  }, [dispatch, props.match.params.id, props.match.params.type]);

  const renderSwitch = (param) => {
    switch (param) {
      case 1:
        return "Primer";
      case 2:
        return "Segundo";
      case 3:
        return "Tercero";
      case 4:
        return "Cuarto";
      case 5:
        return "Quinto";
      case 6:
        return "Sexto";
      default:
        return "Septimo";
    }
  };

  const renderIf = (param) => {
    if ("primer periodo".toLowerCase().includes(param.toLowerCase())) {
      return 1;
    } else if ("segundo periodo".toLowerCase().includes(param.toLowerCase())) {
      return 2;
    } else if ("tercer periodo".toLowerCase().includes(param.toLowerCase())) {
      return 3;
    } else if ("cuarto periodo".toLowerCase().includes(param.toLowerCase())) {
      return 4;
    } else if ("quinto periodo".toLowerCase().includes(param.toLowerCase())) {
      return 5;
    } else if ("sexto periodo".toLowerCase().includes(param.toLowerCase())) {
      return 6;
    } else {
      return 7;
    }
  };

  const onAddActionPlan = (item, index) => {
    history.push(`/plan-de-seguimiento/${item?.periodicidad}/${item?.listado_evaluaciones?.evaluaciones_factor[0][0]}/${item?.listado_evaluaciones?.evaluaciones_competencia[0][0]}/${item?.evaluado}`)
    /* if (item.evaluacion_archivo_plan_accion_gestor) {
      setEdit(true);
    } else {
      setEdit(false);
    }
    setIndex(index);
    setEditItem(item);
    setShowModal(true);
    setValidated(false); */
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModalAcceptEvaluation(true);
  };

  const onShowModalExcel = (item, index) => {
    setIndex(index);
    setEditItem(item);
    setShowModalExcel(true);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEvaluationMonitor(oOffset, limit, e.target.filter.value);
  };

  const onSearchData = (e) => {
    setFilter("");
    setTipoBusc(e);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEvaluationMonitor(oOffset, limit, "", e);
  };

  const onSubmitDocImg = async (req) => {
    const empresaT = editItem.list_evaluado[0].empresa[0];
    const oArea = areas.find(
      (item) => item.descripcion.toLowerCase() === area.toLowerCase()
    );
    const oCarpeta = carpetas.find(
      (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
    );

    const filebase64 = await getBase64(
      document.getElementById("evaluacion_archivo_plan_accion_gestor").files[0]
    );
    const fileName = document.getElementById(
      "evaluacion_archivo_plan_accion_gestor"
    ).files[0].name;
    const fName = String(fileName)
      .substring(0, String(fileName).lastIndexOf("."))
      .replaceAll(/\W/g, "");
    const fExt = `.${String(fileName).substr(
      fileName.lastIndexOf(".") + 1 - fileName.length
    )}`;
    const aFileBase = String(filebase64).split(",");

    var evaluationMon = new FormData();
    evaluationMon.append("codigo_empleado", editItem.list_evaluado[0].codigo);
    evaluationMon.append("tipo_documento", tipoDocumentoGD);
    evaluationMon.append("archivo", aFileBase[1]);
    evaluationMon.append("contentTypeGD", `${aFileBase[0]},`);
    evaluationMon.append("origen", fName + fExt);
    evaluationMon.append("nombre", fName);
    evaluationMon.append("extension", fExt);
    // evaluationMon.append("tipo_documento_GD", tipoDocumentoGD);
    evaluationMon.append(
      "descripcion",
      `DESEMPEÑO ${renderSwitch(editItem.periodo)} PERIODO`
    );
    evaluationMon.append("fecha", moment().format("YYYY-MM-DD"));
    evaluationMon.append("id_area", oArea.id);
    evaluationMon.append("id_carpeta_encabezado", oCarpeta.id);
    evaluationMon.append("empresa", empresaT);
    evaluationMon.append(
      "division",
      editItem.list_evaluado[0].Division_Personal_List[0].descripcion
    );
    // evaluationMon.append("id_registro", parseInt(editItem.id));

    const exist =
      document.getElementById("evaluacion_archivo_plan_accion_gestor").files
        .length > 0;
    const _editItem = editItem;
    _editItem.tipo_plan_accion = req.tipo_plan_accion;
    if (edit) {
      dispatch(
        editEvaluationMonitorGD(
          evaluationMon,
          setShowModal,
          _editItem,
          index,
          exist,
          2
        )
      );
    } else {
      dispatch(
        editEvaluationMonitorGD(
          evaluationMon,
          setShowModal,
          _editItem,
          parseInt(index),
          exist,
          1
        )
      );
    }
  };

  const onSubmit = async (req) => {
    let _req = {
      // comentario_evaluado: req.comentario_evaluado,
      fecha_comentario_evaluado: moment().format("YYYY-MM-DD"),
      estado: false,
    };
    if (editItem.list_tipo_evaluacion[0].nombre === "90°") {
      // _req.estado = false;
      _req.comentario_evaluado = req.comentario;
    } else {
      _req.comentario_evaluador = req.comentario;
    }
    dispatch(
      editEvaluationMonitor(
        _req,
        editItem.id,
        index,
        setShowModalAcceptEvaluation,
        editItem.list_tipo_evaluacion[0].nombre,
        editItem.listado_evaluaciones.evaluaciones_competencia[0][0]
      )
    );
  };

  const onNotAccept = async (data, index) => {
    let _req = {
      competencia_encabezado_id:
        data.listado_evaluaciones.evaluaciones_competencia[0][0],
      factor_encabezado_id: data.id,
    };
    if (
      window.confirm(
        "¿Esta seguro que quiere rechazar la evaluacion de desempeño?"
      )
    ) {
      dispatch(
        editEvaluationMonitorNotAccept(
          _req,
          data.id,
          index,
          data.list_tipo_evaluacion[0].nombre
        )
      );
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEvaluationMonitor(oOffset, limit, oSearch);
  };

  const onDelete = (item, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(
        deleteEvaluationMonitor(
          {
            evaluacion_competencia:
              item.listado_evaluaciones.evaluaciones_competencia[0][0],
            evaluacion_factor:
              item.listado_evaluaciones.evaluaciones_factor[0][0],
          },
          index
        )
      );
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);
  const closeShowModalExcel = () => setShowModalExcel(false);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        {/* <Container fluid> */}
        <div
          className={`${
            props.match.params.type ? "container mt-3 mb-3" : "container-fluid"
          }`}
        >
          {loadingFicha_Empleado ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              {props.match.params.type ? (
                <>
                  <UserHeadDetail
                    data={ficha_empleado}
                    type={props.match.params.type}
                  />
                </>
              ) : null}
              <div
                className={`${
                  props.match.params.type
                    ? "my-4"
                    : "my-1 pl-md-4 pr-md-3 pl-2 pr-1"
                } d-flex flex-wrap justify-content-between align-items-center`}
              >
                {props.match.params.type ? (
                  <>
                    <UserHeadDetailMenu
                      id={props.match.params.id}
                      type={props.match.params.type}
                    />
                    <div
                      className="mt-4 mb-3 px-2 d-flex aling-items-center justify-content-between"
                      style={{ width: "100%" }}
                    >
                      <h5 className="font-weight-bold text-uppercase m-0">
                        Evaluaciones
                      </h5>
                      <div>
                        <span className="text-muted mr-3">
                          <i className="material-icons">vpn_key</i> Código:{" "}
                          {ficha_empleado.codigo}
                        </span>
                        <span className="text-muted mr-3">
                          <i className="material-icons">timer</i> Antigüedad:{" "}
                          {parseInt(ficha_empleado.antiguedad_laboral) < 1
                            ? ` ${parseInt(
                                ficha_empleado.antiguedad_laboral
                              )} meses`
                            : ` ${parseInt(
                                parseInt(ficha_empleado.antiguedad_laboral) / 12
                              )} años`}
                          {Math.floor(
                            (parseInt(ficha_empleado.antiguedad_laboral) / 12 -
                              parseInt(
                                parseInt(ficha_empleado.antiguedad_laboral) / 12
                              )) *
                              12
                          ) > 0
                            ? ` ${Math.floor(
                                (parseInt(ficha_empleado.antiguedad_laboral) /
                                  12 -
                                  parseInt(
                                    parseInt(
                                      ficha_empleado.antiguedad_laboral
                                    ) / 12
                                  )) *
                                  12
                              )} meses`
                            : null}
                        </span>
                        <span className="text-muted">
                          <i className="material-icons">moving</i>{" "}
                          {ficha_empleado.Relacion_Laboral_List
                            ? ficha_empleado.Relacion_Laboral_List[0]
                                .descripcion
                            : "No ingresado aún"}
                        </span>
                      </div>
                    </div>
                  </>
                ) : null}
                <Col
                  xs="auto"
                  className="d-flex flex-wrap justify-content-start align-items-center"
                >
                  <Row className="d-flex flex-wrap justify-content-start align-items-center">
                    {props.match.params.type ? (
                      " "
                    ) : (
                      <>
                        <Button
                          onClick={() =>
                            history.push(
                              `/evaluacion-desempenio/monitor-de-colaboradores`
                            )
                          }
                          variant="link"
                          className="font-weight-bold text-dark p-0 mr-2"
                        >
                          <i className="material-icons">arrow_back</i>
                        </Button>
                        <div
                          style={{
                            width: "520px",
                            // height: "20px",
                            // overflow: "hidden",
                            // position: "relative",
                            // display: "inline-block",
                            // textOverflow: "ellipsis",
                            // whiteSpace: "nowrap",
                          }}
                          // className="font-weight-bold text-uppercase"
                        >
                          {/* <input
                    name="nada"
                    placeholder={`${tipoBusqueda.desc}`}
                    className="pb-0 font-weight-bold text-uppercase formImput"
                    type="text"
                    readOnly
                    value={`${props.match.params.nombreColab} - ${props.match.params.nombreFuncion} - ${props.match.params.nombreDep}`}
                  /> */}
                          <h6 className="text-uppercase">
                            <b>
                              {props.match.params.nombreColab} -{" "}
                              {props.match.params.nombreFuncion.replaceAll(
                                "-",
                                "/"
                              )}{" "}
                              -{" "}
                              {props.match.params.nombreDep.replaceAll(
                                "-",
                                "/"
                              )}
                            </b>
                          </h6>
                        </div>
                      </>
                    )}
                  </Row>
                </Col>
                <Form onSubmit={onSearch}>
                  <Row className="justify-content-sm-end align-items-center flex-nowrap">
                    <Col xs="auto">
                      <Row>
                        <Form.Label column xs="auto">
                          <b>Buscar:</b>
                        </Form.Label>
                        <Col md="8" xs="auto" className="px-0">
                          <Form.Control
                            name="filter"
                            id="filter"
                            placeholder={`${tipoBusqueda.desc}`}
                            className="rounded-pill form-control-sm"
                            type="search"
                          ></Form.Control>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="auto">
                      <ButtonGroup>
                        <Button
                          onClick={() => seeAll()}
                          variant="light"
                          size="sm"
                          className="rounded-circle mr-1"
                        >
                          <i className="material-icons">list</i>
                        </Button>
                        <Dropdown className="ml-1 mr-1">
                          <Dropdown.Toggle
                            variant="light"
                            className="btn-sm font rounded-pill"
                          >
                            <i className="material-icons">filter_list</i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {filters.map((item) => (
                              <Dropdown.Item
                                onClick={() => setTipoBusqueda(item)}
                                key={item.id}
                              >
                                {item.desc}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </ButtonGroup>
                    </Col>
                  </Row>
                </Form>
              </div>
              <div className="px-2">
                <hr />
              </div>
              <Col>
                <Row className="d-flex justify-content-between">
                  <div className="px-1 mb-1">
                    <div className="d-flex flex-wrap justify-content-start align-items-center">
                      <Button
                        className="rounded-pill mr-1 sm-mb-2"
                        disabled={loading || asignadas}
                        // disabled
                        onClick={() => {
                          if (periodicity.id) {
                            // setTipoBusc(periodicity.id);
                            onSearchData(periodicity.id);
                          } else {
                            if (
                              props.match.params.idEmpresa &&
                              !parseInt(props.match.params.idEmpresa)
                            ) {
                              toastr.info("La empresa no existe.");
                            } else {
                              toastr.info("La periodicidad no existe.");
                            }
                          }
                        }}
                        variant="secondary"
                        type="submit"
                      >
                        {loading && (
                          <Spinner
                            className="mr-2"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                        Evaluaciones actuales
                      </Button>
                      <Button
                        className="rounded-pill"
                        disabled={loading || asignadas}
                        // disabled
                        onClick={() => {
                          // setTipoBusc(null);
                          onSearchData("");
                        }}
                        variant="secondary"
                        type="submit"
                      >
                        {loading && (
                          <Spinner
                            className="mr-2"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                        Historial de evaluaciones
                      </Button>
                    </div>
                  </div>
                  {/* {props.match.params.type &&
                  parseInt(props.match.params.id) === id ? (
                    <Button
                      className="rounded-pill"
                      disabled={loading}
                      // disabled
                      onClick={() => {
                        // setTipoBusc(null);
                        setAsignadas(!asignadas);
                        _getEvaluationMonitor(
                          offset,
                          limit,
                          filter,
                          tipoBusc,
                          !asignadas
                        );
                      }}
                      variant="secondary"
                      type="submit"
                    >
                      {loading && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      {!asignadas
                        ? "Evaluaciones asignadas"
                        : "Mis evaluaciones"}
                    </Button>
                  ) : null} */}
                </Row>
              </Col>
              {loading || loadingPeriodicity ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : (
                evaluationMonitorsLength > 0 && (
                  <>
                    <Card className="border-0">
                      <Card.Body className="px-1 px-sm-2">
                        <CustomTable
                          columns={columns}
                          data={evaluationMonitors}
                        />
                      </Card.Body>
                    </Card>
                    <CustomPagint
                      limit={limit}
                      setLimit={setLimit}
                      offset={offset}
                      setOffset={setOffset}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      dataLenght={evaluationMonitorsLength}
                      pages={pages}
                      pagFunc={_getEvaluationMonitor}
                    />
                  </>
                )
              )}
              {!loading &&
                evaluationMonitorsLength === 0 &&
                evaluationMonitorError === "" &&
                (props.match.params.idEmpresa ||
                  !isNaN(props.match.params.idEmpresa)) && (
                  <Alert variant="info" className="my-4">
                    Aún no hay registros, contacte al administrador para mas
                    información
                  </Alert>
                )}
              {((!!evaluationMonitorError || evaluationMonitorError !== "") &&
                !loading &&
                (props.match.params.idEmpresa ||
                  !isNaN(props.match.params.idEmpresa))) ||
              (props.match.params.type && evaluationMonitorError !== "") ? (
                <Alert variant="danger" className="my-4">
                  {evaluationMonitorError}
                </Alert>
              ) : null}
              {evaluationMonitorsLength === 0 &&
              evaluationMonitorError === "" &&
              !loading &&
              (!props.match.params.idEmpresa ||
                isNaN(props.match.params.idEmpresa)) ? (
                <Alert variant="danger" className="my-4">
                  El colaborador no tiene asignado una empresa
                </Alert>
              ) : null}
            </>
          )}
        </div>
        <ExcelFile
          item={editItem}
          setItem={setItem}
          index={index}
          show={showModalExcel}
          handleClose={closeShowModalExcel}
        />
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmitDocImg}
          initialValues={{
            tipo_plan_accion: edit ? editItem.tipo_plan_accion : "",
            fecha_inicio: edit ? editItem.fecha_inicio : "",
            fecha_fin: edit ? editItem.fecha_fin : "",
            evaluacion_archivo_plan_accion_gestor: "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar plan de acción" : "Agregar plan de acción"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Row} className="mb-md-0">
                  <Form.Label column sm={3}>
                    Tipo de plan de acción
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loaderPlanAccion ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="tipo_plan_accion"
                          name="tipo_plan_accion"
                          className="col rounded-pill"
                          disabled={!editItem.estado}
                          onBlur={handleBlur("tipo_plan_accion")}
                          value={values.tipo_plan_accion}
                          onChange={handleChange}
                          isValid={
                            touched.tipo_plan_accion && !errors.tipo_plan_accion
                          }
                          isInvalid={
                            touched.tipo_plan_accion && !!errors.profesion
                          }
                        >
                          <option key="" value="" disabled>
                            Seleccione un tipo de plan de acción
                          </option>
                          {planAccion &&
                            planAccion.data.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.descripcion}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loaderPlanAccion && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    {touched.profesion && errors.profesion && (
                      <Col>
                        <small className="text-danger">
                          {errors.profesion}
                        </small>
                      </Col>
                    )}
                    {!loaderPlanAccion &&
                      planAccion &&
                      planAccion.count === 0 && (
                        <Col>
                          <small className="text-danger">
                            **No se encontraron Profesiones
                          </small>
                        </Col>
                      )}
                    {!!planAccionFalla && (
                      <Col>
                        <small className="text-danger">
                          **{planAccionFalla}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-md-0">
                  <Form.Label column sm={3}>
                    Fecha de inicio
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.Control
                          id="fecha_inicio"
                          name="fecha_inicio"
                          className="rounded-pill"
                          required
                          type="date"
                          disabled={!editItem.estado}
                          value={values.fecha_inicio}
                          placeholder=""
                          onBlur={handleBlur("fecha_inicio")}
                          onChange={(e) => handleChange(e)}
                          isInvalid={
                            touched.fecha_inicio && !!errors.fecha_inicio
                          }
                        ></Form.Control>
                      </Col>
                    </Row>
                    {touched.fecha_inicio && errors.fecha_inicio && (
                      <Col>
                        <small className="text-danger">
                          {errors.fecha_inicio}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Fecha de fin
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.Control
                          id="fecha_fin"
                          name="fecha_fin"
                          className="rounded-pill"
                          required
                          type="date"
                          disabled={!editItem.estado}
                          value={values.fecha_fin}
                          placeholder=""
                          onBlur={handleBlur("fecha_fin")}
                          onChange={(e) => handleChange(e)}
                          isInvalid={touched.fecha_fin && !!errors.fecha_fin}
                        ></Form.Control>
                      </Col>
                    </Row>
                    {touched.fecha_fin && errors.fecha_fin && (
                      <Col>
                        <small className="text-danger">
                          {errors.fecha_fin}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Plan de acción
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.File
                          id="evaluacion_archivo_plan_accion_gestor"
                          name="evaluacion_archivo_plan_accion_gestor"
                          className="col position-relative my-2"
                          disabled={!editItem.estado}
                          value={values.evaluacion_archivo_plan_accion_gestor}
                          onChange={handleChange}
                          onBlur={handleBlur(
                            "evaluacion_archivo_plan_accion_gestor"
                          )}
                          isValid={
                            touched.evaluacion_archivo_plan_accion_gestor &&
                            !errors.evaluacion_archivo_plan_accion_gestor
                          }
                          isInvalid={
                            touched.evaluacion_archivo_plan_accion_gestor &&
                            !!errors.evaluacion_archivo_plan_accion_gestor
                          }
                        />
                      </Col>
                    </Row>
                    {touched.evaluacion_archivo_plan_accion_gestor &&
                      errors.evaluacion_archivo_plan_accion_gestor && (
                        <Col>
                          <small className="text-danger">
                            {errors.evaluacion_archivo_plan_accion_gestor}
                          </small>
                        </Col>
                      )}
                  </Col>
                </Form.Group>
                {editItem && editItem.evaluacion_archivo_plan_accion_gestor ? (
                  <>
                    <h6 className="text-muted ml-3">Archivo actual</h6>
                    <ul className="list-unstyled">
                      <LinkDescargaGD
                        id={editItem.id}
                        filters={{
                          email: email,
                          id: editItem
                            .list_evaluacion_archivo_plan_accion_gestor[0]
                            .id_documento,
                          llave:
                            editItem
                              .list_evaluacion_archivo_plan_accion_gestor[0]
                              .llave,
                        }}
                        origen={
                          editItem.list_evaluacion_archivo_plan_accion_gestor[0]
                            .origen
                        }
                        cType={
                          editItem.list_evaluacion_archivo_plan_accion_gestor[0]
                            .contentTypeGD
                        }
                      />
                    </ul>
                  </>
                ) : null}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                {editItem.estado && (
                  <Button
                    className="rounded-pill"
                    disabled={saveLoading}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoading && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                )}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      <Modal
        show={showModalAcceptEvaluation}
        onHide={() => setShowModalAcceptEvaluation(false)}
      >
        <Formik
          validationSchema={schemaAcceptEvaluation}
          onSubmit={onSubmit}
          initialValues={{
            comentario: edit
              ? props.match.params.type
                ? editItem.comentario_evaluado
                  ? editItem.comentario_evaluado
                  : ""
                : editItem.comentario_evaluador
                ? editItem.comentario_evaluador
                : ""
              : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  Aceptación de la Evaluación
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {formError}
                  </Alert>
                )}
                <div className="mb-4 border-left border-info rounded">
                  {editItem.list_tipo_evaluacion[0].nombre === "0°" ? (
                    <Alert variant="light">
                      <p>
                        Después de haber leído, entendido y revisado con el
                        colaborador la evaluación del desempeño. Envió esta
                        evaluación a los{" "}
                        {editItem.comentario_evaluado
                          ? moment(editItem.fecha_comentario_evaluado).format(
                              "DD"
                            )
                          : moment(fechaActual).format("DD")}{" "}
                        del{" "}
                        {editItem.comentario_evaluado
                          ? moment(editItem.fecha_comentario_evaluado).format(
                              "MM"
                            )
                          : moment(fechaActual).format("MM")}{" "}
                        del{" "}
                        {editItem.comentario_evaluado
                          ? moment(editItem.fecha_comentario_evaluado).format(
                              "YYYY"
                            )
                          : moment(fechaActual).format("YYYY")}{" "}
                        como señal de acuerdo mutuo al resultado obtenido.
                      </p>
                    </Alert>
                  ) : (
                    <Alert variant="light">
                      <p>
                        Después de haber leído, entendido y revisado con mi jefe
                        la evaluación del desempeño. Envió esta evaluación a los{" "}
                        {editItem.comentario_evaluado
                          ? moment(editItem.fecha_comentario_evaluado).format(
                              "DD"
                            )
                          : moment(fechaActual).format("DD")}{" "}
                        del{" "}
                        {editItem.comentario_evaluado
                          ? moment(editItem.fecha_comentario_evaluado).format(
                              "MM"
                            )
                          : moment(fechaActual).format("MM")}{" "}
                        del{" "}
                        {editItem.comentario_evaluado
                          ? moment(editItem.fecha_comentario_evaluado).format(
                              "YYYY"
                            )
                          : moment(fechaActual).format("YYYY")}{" "}
                        como señal de acuerdo mutuo al resultado obtenido.
                      </p>
                    </Alert>
                  )}
                </div>
                <Form.Group as={Row}>
                  <Form.Label column sm={2}>
                    Comentario:
                  </Form.Label>
                  <Col sm={10}>
                    <Row>
                      <Col>
                        <Form.Control
                          id="comentario"
                          name="comentario"
                          isInvalid={touched.comentario && errors.comentario}
                          isValid={touched.comentario && !errors.comentario}
                          onBlur={handleBlur("comentario")}
                          onChange={handleChange}
                          value={values.comentario}
                          className="rounded"
                          as="textarea"
                          placeholder=""
                          disabled={!editItem.estado}
                        ></Form.Control>
                        {touched.comentario && errors.comentario && (
                          <div>
                            <small className="text-danger">
                              {errors.comentario}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModalAcceptEvaluation(false)}
                >
                  Cerrar
                </Button>
                {editItem.estado && (
                  <>
                    <Button
                      className="rounded-pill"
                      disabled={saveLoading}
                      variant="primary"
                      type="submit"
                    >
                      {saveLoading && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      {/* {editItem.list_tipo_evaluacion[0].nombre === "90°"
                        ? "Aceptar"
                        : "Guardar"} */}
                      Aceptar
                    </Button>
                  </>
                )}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default EvaluationMonitor;
